<!-- <div class="account-pages my-5 pt-sm-5 bg-color"> -->
<div class="account-pages py-4 auth-layout bg-color">
    <div class="container centered-div ">
        <div class="row justify-content-center gutter-x-0">
            <div class="col-md-10 col-lg-8 col-xl-7">
                <div class="">
                    <div class="row gutter-x-0">
                        <div class="col-12 text-center">
                            <a routerLink="/">
                                <img src="assets/images/identity/logo-white.svg" alt="" class="img-fluid logo-auth">
                            </a>
                        </div>
                    </div>
                </div>
                
                <router-outlet />
                   
            </div>
        </div>
    </div>
</div>